import { Observable } from 'rxjs';

export namespace MonitorEngine {
  export enum State {
    START,
    PAUSE,
    STOP,
  }

  export interface StartOptions {
    dueTime?: number | Date;
    period?: number; // Refresh period
    // forceChange?: boolean; // If you want to force change to be triggered even if value did not change
    // duration?: number; // Infinite by default
  }

  export type EventType =
    | 'START'
    | 'STOP'
    | 'PAUSE'
    | 'READ_ERROR'
    | 'READ_SUCCESS';

  export interface Event<PayloadType = any> {
    type: EventType;
    payload: PayloadType;
  }

  export interface VariableMonitoringUpdate<DataType> {
    update(totalMs: number): Promise<DataType>;
  }
}

export interface MonitorEngineInterface {
  // configure(config: VariableConfig): this;

  start(options?: MonitorEngine.StartOptions): this;

  /**
   * Stop monitoring
   * It will terminates values and event streams (complete will be called on your subsriptions)
   */
  stop(): this;

  /**
   * Pause monitoring
   */
  pause(): this;

  // /**
  //  * Values stream
  //  */
  // values(): Observable<DataType>;

  // /**
  //  * Event stream
  //  */
  // events(): Observable<MonitorEngine.Event>;

  // /**
  //  *
  //  * @param notify a new value
  //  */
  // notifyNewValue(value: DataType): void;
}
